import type { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import type { RootState } from '../common/types';
import { PageLoader } from '../components';
import Helpers from '../utils/Helpers';

export const AuthGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const isLoading = useSelector((state: RootState) => state.auth.loading);

  if (isLoading) {
    return <PageLoader />;
  }

  return Helpers.isAuthenticated() ? children : <Redirect to="/login" />;
};
